export default __webpack_public_path__ + "98b450edac2095acd7e6e8d8664668a3.png";